@import '@hevoio/hevo-ui-toolkit/styles/variables';

$body-padding-y: $spacer * 2.5;

.dialogBody {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: $body-padding-y;
  padding-bottom: $body-padding-y;
}

.concern {
  font-weight: $font-weight-bold;
  font-size: $font-size-subheader;
  line-height: 24px;
  text-align: center;
  max-width: 250px;
  margin-top: $spacer * 1.25;
}

.supportExecutives {
  height: 60px;
  img {
    height: 100%;
  }
}
